import { render, staticRenderFns } from "./UserNavDropdown.vue?vue&type=template&id=4a8d2850&scoped=true&"
import script from "./UserNavDropdown.vue?vue&type=script&lang=js&"
export * from "./UserNavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserNavDropdown.vue?vue&type=style&index=0&id=4a8d2850&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d2850",
  null
  
)

export default component.exports